export const ScreenSizeXsmallMin = "0px";
export const ScreenSizeXsmallMax = "480px";
export const ScreenSizeSmallMin = "480px";
export const ScreenSizeSmallMax = "768px";
export const ScreenSizeMediumMin = "768px";
export const ScreenSizeMediumMax = "1024px";
export const ScreenSizeLargeMin = "1024px";
export const ScreenSizeLargeMax = "1280px";
export const ScreenSizeXlargeMin = "1280px";
export const ScreenSizeXlargeMax = "1600px";
export const ScreenSizeWideMin = "1600px";
export const ScreenSizeWideMax = "100000px";
